export default __webpack_public_path__ + "static/nis2021-4a6c6ac1b72a989670f5836fa3dbb947.jpg";